import React, { useState } from "react";
import {
  TermsAcceptanceDialog,
  getSwitchBackTarget,
  getSwitchedFrom,
} from "@merge-api/merge-javascript-shared";
import { onLogout } from "../../../api-client/APIClient";
import useAppContext from "../../context/useAppContext";
import AuthPageWrapper from "../../pages/authentication/shared/AuthPageWrapper";
import { showErrorToast } from "../../shared/Toasts";
import useProductSwitcher from "../useProductSwitcher";
import { ACCEPT_FAILED_MESSAGE, SIGN_OUT_FAILED_MESSAGE } from "./constants";
import acceptTerms from "./utils/acceptTerms";

const TermsAcceptancePage = () => {
  // state
  const [switchedFrom] = useState(() => getSwitchedFrom("unified"));
  const [isAccepting, setIsAccepting] = useState(false);
  const [isSigningOut, setIsSigningOut] = useState(false);

  // hooks
  const { setUser } = useAppContext();
  const switcher = useProductSwitcher();

  // derived state
  const switchBackTarget = getSwitchBackTarget(switchedFrom, switcher);

  // event handlers
  const onAccept = () => {
    setIsAccepting(true);
    acceptTerms()
      .then(setUser)
      .catch(() => showErrorToast(ACCEPT_FAILED_MESSAGE))
      .finally(() => setIsAccepting(false));
  };

  const onCancel = () => {
    if (switchBackTarget !== null) {
      switcher.switchTo(switchBackTarget);
      return;
    }
    setIsSigningOut(true);
    onLogout({
      onError: () => {
        setIsSigningOut(false);
        showErrorToast(SIGN_OUT_FAILED_MESSAGE);
      },
    });
  };

  // render
  return (
    <AuthPageWrapper>
      <TermsAcceptanceDialog
        open
        onAccept={onAccept}
        onCancel={onCancel}
        isAccepting={isAccepting}
        isCancelling={isSigningOut || switcher.switchingTo !== null}
      />
    </AuthPageWrapper>
  );
};

export default TermsAcceptancePage;
